import { proxy } from 'valtio';

import type { EntityId, RelationDirection } from '@canvas/model';

type IssueLink =
  | {
      connectorId: undefined;
      fromUrl: undefined;
      toUrl: undefined;
      linkType: undefined;
      linkIsOutward: undefined;
      direction: undefined;
      onLink?: () => void;
    }
  | {
      connectorId: EntityId;
      fromUrl: string;
      toUrl: string;
      linkType: string;
      linkIsOutward: boolean;
      direction: RelationDirection;
      onLink?: () => void;
    };

export const defaultIssueLink = {
  connectorId: undefined,
  fromUrl: undefined,
  toUrl: undefined,
  linkType: undefined,
  linkIsOutward: undefined,
  direction: undefined,
  onLink: undefined,
};

export const currentIssueLink: IssueLink = proxy(defaultIssueLink);
